<template>
  <div v-if="visible" class="modal">
    <div class="modal-content" :class="modalTypeClass">
      <h3 class="modal-title">{{ title }}</h3>
      <p class="modal-message">{{ message }}</p>
      <button @click="closeModal" :class="buttonTypeClass">關閉</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      title: '',
      message: '',
      type: 'info' // 默認為信息提示類型
    };
  },
  computed: {
    modalTypeClass() {
      return {
        'modal-success': this.type === 'success',
        'modal-error': this.type === 'error',
        'modal-info': this.type === 'info'
      };
    },
    buttonTypeClass() {
      return {
        'button-success': this.type === 'success',
        'button-error': this.type === 'error',
        'button-info': this.type === 'info'
      };
    }
  },
  methods: {
    show(message, title = '提示', type = 'info') {
      this.message = message;
      this.title = title;
      this.type = type;
      this.visible = true;
    },
    closeModal() {
      this.visible = false;
      this.$emit('closed');
    }
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  background: white;
  padding: 16px 32px;
  border-radius: 8px;
  text-align: center;
  max-width: 400px;
}

/* 類型樣式 */
.modal-success {
  border: 2px solid #28a745; /* 綠色邊框 */
}
.modal-error {
  border: 2px solid #dc3545; /* 紅色邊框 */
}
.modal-info {
  border: 2px solid #007bff; /* 藍色邊框 */
}

.modal-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.modal-message {
  font-size: 16px;
  margin-bottom: 16px;
}

/* 不同類型文字顏色 */
.modal-success .modal-message {
  color: #28a745; /* 綠色文字 */
}
.modal-error .modal-message {
  color: #dc3545; /* 紅色文字 */
}
.modal-info .modal-message {
  color: #007bff; /* 藍色文字 */
}

/* 按鈕樣式 */
button {
  margin-top: 16px;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.button-success {
  background-color: #28a745;
  color: white;
}
.button-error {
  background-color: #dc3545;
  color: white;
}
.button-info {
  background-color: #007bff;
  color: white;
}

button:hover {
  opacity: 0.9;
}
</style>
